import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { PointHistoryRow } from '@models/point';
import { PointHistoryStatusKr } from '@models/point/extension';
import dayjs from 'dayjs';

import styles from './styles.module.scss';

interface Props {
    pointHistory: PointHistoryRow;
}

function PointLogRow({ pointHistory }:Props) {
  const {
    amount, status, shopName, createdAt,
  } = pointHistory;
  return (
        <Column fullWidth spacing={4}>
            <Text size='lg' color={colors.white} fontWeight='medium'>
                {PointHistoryStatusKr[status]} {shopName}
            </Text>
            <Text color={colors.white}>
                {dayjs(createdAt).format('YYYY.MM.DD.')}
            </Text>
            <Row fullWidth className={styles.type}
                 spacing={20}
                 justify='flex-end'>
                <Text size='xl' color={colors.white}>
                    {status === 'EARNED' ? '+' : '-'}
                </Text>
                <Text size='xl' color={colors.white} fontWeight='bold'>
                    {amount}점
                </Text>
            </Row>
        </Column>
  );
}

export default PointLogRow;
